var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#bda6cc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0433 4C19.0249 4 14.4518 5.65746 11.7469 7.01231C11.5031 7.13439 11.2746 7.25402 11.0622 7.36975C10.642 7.59878 10.2852 7.81256 10 8L13.0777 12.5307L14.5263 13.1074C20.1889 15.9645 27.7825 15.9645 33.4451 13.1074L35.09 12.254L38 8C37.5736 7.7157 36.9838 7.37078 36.2581 7.00403C36.2139 6.98167 36.1692 6.95924 36.1239 6.93673C33.4307 5.59663 28.9687 4 24.0433 4ZM16.8852 9.12906C15.7776 8.92471 14.6893 8.64286 13.662 8.31949C16.1968 7.19394 19.9743 6 24.0433 6C26.8626 6 29.5282 6.57325 31.733 7.2991C29.1492 7.66384 26.3919 8.27955 23.7654 9.03939C21.6987 9.63727 19.2829 9.57147 16.8852 9.12906Z",
    fill: "#bda6cc"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6185 14.7556L34.3461 14.893C28.1168 18.036 19.8546 18.036 13.6254 14.893L13.3664 14.7624C4.00908 25.0304 -5.80757 44.2853 24.0433 43.9968C53.8737 43.7085 43.9033 24.6761 34.6185 14.7556ZM25.7113 22H22.2887V23.6C21.1765 23.5974 20.1071 23.9999 19.3068 24.7222C18.5067 25.4443 18.0388 26.4294 18.0023 27.4687C17.9658 28.508 18.3636 29.5197 19.1113 30.2894C19.8591 31.0591 20.8981 31.5263 22.0081 31.592L22.2887 31.6H25.7113L25.8653 31.6128C26.0626 31.6462 26.2411 31.7433 26.3696 31.8872C26.4981 32.031 26.5686 32.2126 26.5686 32.4C26.5686 32.5874 26.4981 32.769 26.3696 32.9128C26.2411 33.0567 26.0626 33.1538 25.8653 33.1872L25.7113 33.2H18.8661V36.4H22.2887V38H25.7113V36.4C26.8235 36.4026 27.8929 36.0001 28.6932 35.2778C29.4933 34.5557 29.9612 33.5706 29.9977 32.5313C30.0342 31.492 29.6364 30.4803 28.8887 29.7106C28.1409 28.9409 27.1019 28.4737 25.9919 28.408L25.7113 28.4H22.2887L22.1347 28.3872C21.9374 28.3538 21.7589 28.2567 21.6304 28.1128C21.5019 27.969 21.4314 27.7874 21.4314 27.6C21.4314 27.4126 21.5019 27.231 21.6304 27.0872C21.7589 26.9433 21.9374 26.8462 22.1347 26.8128L22.2887 26.8H29.1339V23.6H25.7113V22Z",
    fill: "#bda6cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagSvgrepoCom);
export default __webpack_public_path__ + "static/media/money-bag-svgrepo-com.fafce4d29bf714ff6c727937738b2e70.svg";
export { ForwardRef as ReactComponent };